import { ENV } from 'common/constants';
import { selectUser } from 'common/store/slices/auth.slice';
import { useSelector } from 'react-redux';

function useDevMode(): boolean {
  const devMode = ENV.VITE_DEVELOPMENT_PAGE === 'true';
  const user = useSelector(selectUser);

  return devMode && user.companyName === 'Kwello';
}

export default useDevMode;
